var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pdfURL)?_c('div',{staticClass:"relative w-full"},[_c('iframe',{attrs:{"type":"application/pdf","width":_vm.width,"height":_vm.height,"src":_vm.pdfURL}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }